import { IGif } from "services/types";
import { boostHistory } from "./boostHistory";

interface IMixWithBoostedProps {
  gifs: IGif[];
  boostedPostData: IGif[];
  tiles: boolean;
}

interface IBoostedGifsPos {
  id: string;
  position: number;
}

interface IBoostSpread {
  [id: string]: string;
}

const DEFAULT_POSITION = 5;

export const spreadBoosted = (sources: IBoostedGifsPos[]): IBoostSpread => {
  const res: IBoostSpread = {};

  sources.forEach((boost: IBoostedGifsPos) => {
    for (let pos = boost.position; ; pos += boost.position) {
      if (!(pos in res)) {
        res[pos] = boost.id;
        break;
      }
    }
  });

  return res;
};

export const mixWithBoosted = ({ gifs, boostedPostData, tiles }: IMixWithBoostedProps) => {
  if (tiles) {
    const pureGifs = gifs.filter(
      gif => !boostedPostData.map((post: any) => post.id).includes(gif.id)
    );

    return pureGifs;
  }

  const notExpiredBoostGifs = boostHistory.getCurrent();

  const newBoostedPost = boostedPostData.filter(gif => !notExpiredBoostGifs.includes(gif.id));

  const adaptBoosted = newBoostedPost.map(gif => ({ id: gif.id, position: gif?.cta?.position || DEFAULT_POSITION }));

  const positions = spreadBoosted(adaptBoosted);

  const sortedPositions = Object.keys(positions)
    .sort((a, b) => parseInt(a) - parseInt(b))
    .reduce((result: any, key) => {
      result[key] = positions[key];
      return result;
    }, {});

  const newArr: IGif[] = [];
  let offset = 0;

  for (let i = 0; i < gifs.length; i++) {
    newArr.push(gifs[i]);

    if (sortedPositions[i]) {
      const boostedGif = newBoostedPost.find(el => el.id === sortedPositions[i]);

      if (boostedGif) {
        newArr.splice((offset + i), 0, boostedGif);
        offset++;
      }
    }
  }

  return newArr;
};
